<div class="p-2 light-blue-header d-flex flex-row justify-content-between modal-header">
    <div class="p-2 modal-title"><h5>Rxdb Paths</h5></div>
    <button class="p-0 m-0 btn" style="line-height: .8; color: white" (click)="onCancel()" aria-label="Close">
        <i class="fa fa-window-close"></i>
    </button>
</div>

<div class="container-fluid busy-overlay-parent p-2" [ngClass]="bProcessing?'disabled':''">
    <div *ngIf="bProcessing" class="font-weight-bold busy-overlay">
        <i class="fa fa-spinner fa-spin"></i>&nbsp;Processing...
    </div>
    <form #pathForm="ngForm">
        <table class="edit-table table table-striped table-condensed">
            <thead>
            </thead>
            <tbody>
                <tr *ngIf="tmpPath?.id">
                    <th>ID</th>
                    <td>{{tmpPath?.id}}</td>
                </tr>
                <tr>
                    <th>Building ID</th>
                    <td>
                        <select name="buildingId" type='text' class="form-control w-100" [(ngModel)]="tmpPath.buildingId" #buildingId="ngModel"
                            required buildingId [ngClass]="{ 'invalid-input': buildingId.invalid && (buildingId.dirty || buildingId.touched)}">
                            <option value="">{{tmpPath.buildingId}}</option>
                            <option *ngFor="let rxBuilding of rxBuildings">{{rxBuilding.id}}</option>
                        </select>
                    
                    </td>
                </tr>
                <tr>
                    <th>Description</th>
                    <td>
                        <textarea name="description" rows="4" class="form-control" style="resize: none"
                        [(ngModel)]="tmpPath.description" #description="ngModel" 
                        [ngClass]="{ 'invalid-input': description.invalid && (description.dirty || description.touched)}"
                        ></textarea>
                    </td>
                </tr>
                <tr>
                    <th>Deleted</th>
                    <td>
                        <input id="deleted" name="deleted" type='checkbox' class="form-control move-left"
                            [(ngModel)]="tmpPath.deleted" #deleted="ngModel"
                            [ngClass]="{ 'invalid-input': deleted.invalid && (deleted.dirty || deleted.touched)}" >
                    </td>
                </tr>
            </tbody>
        </table>
        <div *ngIf="errorMsg" class="alert alert-danger">{{errorMsg}}</div>
    </form>
</div>

<div class="modal-footer">
    <button  (click)="onSave()" class="btn btn-primary">Save</button>
    <button (click)="onCancel()" class="btn btn-secondary">Cancel</button>
</div>
